import { getConsoleBaseUrl, STATUS_CODE } from '@kc-console/core';

import { CookieKeyMap } from '../../../constants/cookie';
import { parseCookies } from '../../../utils/cookie/parseCookies';
import { getRequestUrlData } from '../../../utils/getRequestUrlData';

import type { ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../../types';

const NON_AUTH_REQUIRED_PAGES = ['/domain', '/signin'] as const;

/**
 * Account 에서 서버사이드 라우트 이동 시 호출되어야하는 예시 가드
 * @description
 * 실제 개발 시, 필요한 가드를 정의해서 사용
 */
export const checkValidTokenGuard: Guard<ServiceAppState> = async ({ context }) => {
  const { resolvedUrl } = context;
  const { cookie, urlObj } = getRequestUrlData(context);
  const cookies = parseCookies(cookie || '');
  const cookieToken = cookies[CookieKeyMap.TOKEN_KEY] || '';

  /**
   * cookie token이 있을 경우, 로그인 되어 있다고 판단해서 console로 보낸다.
   * 단, token이 존재하더라도 /domain이나 /signin 관련 화면이 아니면 account 접근을 허용해야 한다.
   * token 검증은 console 서비스의 guards에 위임
   */
  const shouldRedirectToConsole =
    !!cookieToken.trim() &&
    NON_AUTH_REQUIRED_PAGES.some((page: string) => resolvedUrl.startsWith(page));

  if (shouldRedirectToConsole) {
    return {
      redirect: {
        destination: `${getConsoleBaseUrl(urlObj.origin)}/dashboard`,
        permanent: false,
      },
    };
  }

  return { status: STATUS_CODE.OK };
};

checkValidTokenGuard.displayName = 'checkValidTokenGuard';
checkValidTokenGuard.traceCategory = 'session-cookie';
